import React, { ComponentProps, PropsWithChildren } from 'react';
import {
  CloudinaryProvider,
  ThemeProvider,
  ToastProvider,
} from '@sato/components';
import { observer } from 'mobx-react-lite';

import { ResolveEntry } from '@/contentful/components';
import { IEntry } from '@/contentful/types';
import { parseEntry } from '@/contentful/utils/data.utils';

import QueryProvider from '@providers/QueryProvider';
import { localizationStore } from '@stores/localization';

import { I18nProvider } from './I18nProvider';

const entryResolver: ComponentProps<typeof ThemeProvider>['entryResolver'] = (
  entryData: object,
  { isInline } = {}
) => {
  const entry = parseEntry(entryData as IEntry);

  if (!entry) return null;

  return <ResolveEntry entry={entry} options={{ isInline }} />;
};

export const Providers = observer(({ children }: PropsWithChildren) => {
  const language = localizationStore.language;

  return (
    <QueryProvider>
      <CloudinaryProvider
        config={{
          cloud: {
            cloudName: 'sato',
          },
          url: {
            secure: true,
            analytics: false,
          },
        }}
      >
        <ThemeProvider locale={language} entryResolver={entryResolver}>
          <I18nProvider>
            <ToastProvider>{children}</ToastProvider>
          </I18nProvider>
        </ThemeProvider>
      </CloudinaryProvider>
    </QueryProvider>
  );
});
